import { render } from "./PrivacyPolicy.vue?vue&type=template&id=f06040d2"
import script from "../js/privacy-policy.js?vue&type=script&lang=js&external"
export * from "../js/privacy-policy.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__